import { component } from 'picoapp';
import Accordion from 'utils/accordion';

export default component(async (node) => {
  const placeholder = node.querySelector('[data-placeholder]');
  const content = node.querySelector<HTMLElement>('[data-content]');
  const activeFilterIndicator = node.querySelector<HTMLElement>('[data-current-active]');
  const accordionContent = node.querySelector('.accordion--content');

  const filterType = node.dataset.filterItem;

  const accordionParams = {
    toggleIcon: '.accordion__icon',
    singular: true,
    group: 'filter-items',
  };

  let accordion: ReturnType<typeof Accordion>;
  let search: boolean;

  const createSearch = () => {
    const SEARCH_THRESHOLD = 15;
    const items = node.querySelectorAll<HTMLElement>('.js-item');

    if (items.length < SEARCH_THRESHOLD) return;

    accordionContent.insertAdjacentHTML(
      'afterbegin',
      `<input
        type="search"
        placeholder="${theme.strings.collection.filter.search}"
        class="collection__filter--search-input"
        data-search-input
      >`,
    );

    const input = node.querySelector<HTMLInputElement>('[data-search-input]');

    input.addEventListener('keyup', () => {
      const query = input.value;
      const method = query.length === 1 ? 'startsWith' : 'includes';

      items.forEach((item) => {
        item.hidden = !item.textContent.trim().toLowerCase()[method](query.toLowerCase());
      });
    });

    // eslint-disable-next-line consistent-return
    return true;
  };

  document.addEventListener('collection:filter:render', (e: CustomEvent) => {
    const activeFilters = e.detail;
    const currentFilters = activeFilters.find((x) => x.name === filterType);

    if (currentFilters !== undefined) {
      activeFilterIndicator.innerText = currentFilters.vals.length;
      activeFilterIndicator.hidden = false;
    } else {
      activeFilterIndicator.hidden = true;
    }

    search = search || createSearch();

    placeholder.remove();
    content.hidden = false;

    accordion = accordion || Accordion(content, accordionParams); // only first time
  });
});
